export default "__VITE_ASSET__C0eh74Ti__"